(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uh-gallery"] && !Shopify.designMode) return;
  try {
    (()=>{
  const normalize=value=>String(value||'').toLowerCase().trim().replaceAll('ß','ss').replaceAll('ü','ue').replaceAll('ä','ae').replaceAll('ö','oe').replaceAll('/','-').replaceAll(' ','-');
  const aliases={white:'weiss',black:'schwarz',blue:'blau',red:'rot',grey:'grau',gray:'grau',silver:'silber',green:'gruen',yellow:'gelb',brown:'braun','matt-silver':'mattsilber','matt-black':'mattschwarz','dark-green':'dunkelgruen','dark-blue':'dunkelblau','dark-red':'dunkelrot','light-blue':'hellblau','white-light-blue':'weiss-hellblau','white-light-purple':'weiss-helllila'};
  const init=()=>document.querySelectorAll('[data-uh-gallery]').forEach(g=>{
    if(g.dataset.ready)return;g.dataset.ready='true';
    const scope=g.closest('[data-uh-product-scope]'),hero=g.querySelector('[data-gallery-open]'),img=hero.querySelector('img'),caption=g.querySelector('[data-gallery-caption]'),missing=g.querySelector('[data-gallery-missing]'),thumbs=[...g.querySelectorAll('[data-gallery-thumb]')],dialog=g.querySelector('[data-gallery-dialog]'),full=g.querySelector('[data-gallery-full]'),fullCaption=g.querySelector('[data-gallery-full-caption]'),counter=g.querySelector('[data-gallery-count]'),prev=g.querySelector('[data-gallery-prev]'),next=g.querySelector('[data-gallery-next]'),close=g.querySelector('[data-gallery-close]');
    let active=thumbs.find(b=>b.getAttribute('aria-pressed')==='true')||thumbs[0],restoreOverflow='',touchStart=null;
    const visible=()=>thumbs.filter(b=>!b.hidden);
    const show=b=>{if(!b)return;active=b;img.src=b.dataset.src;img.removeAttribute('srcset');img.alt=b.dataset.alt;caption.textContent=b.dataset.alt;thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t===b)));if(dialog.open){full.src=b.dataset.full;full.alt=b.dataset.alt;fullCaption.textContent=b.dataset.alt;const list=visible();counter.textContent=`${list.indexOf(b)+1} / ${list.length}`;prev.disabled=next.disabled=list.length<2;}};
    const select=value=>{const normalized=normalize(value),color=aliases[normalized]||normalized,matches=thumbs.filter(b=>b.dataset.color===color);if(!matches.length){missing.hidden=false;thumbs.forEach(b=>b.hidden=false);return;}missing.hidden=true;thumbs.forEach(b=>b.hidden=b.dataset.color!==color&&b.dataset.color!=='shared');show(matches[0]);};
    const move=delta=>{const list=visible();if(list.length)show(list[(list.indexOf(active)+delta+list.length)%list.length]);};
    thumbs.forEach(b=>b.addEventListener('click',()=>show(b)));
    hero.addEventListener('click',()=>{restoreOverflow=document.documentElement.style.overflow;dialog.showModal();document.documentElement.style.overflow='hidden';show(active);close.focus();});
    close.addEventListener('click',()=>dialog.close());
    dialog.addEventListener('close',()=>{document.documentElement.style.overflow=restoreOverflow;hero.focus();});
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
    dialog.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move(e.key==='ArrowLeft'?-1:1);}});
    full.addEventListener('touchstart',e=>{touchStart=e.changedTouches[0].clientX;},{passive:true});
    full.addEventListener('touchend',e=>{if(touchStart!==null){const delta=e.changedTouches[0].clientX-touchStart;if(Math.abs(delta)>50)move(delta<0?1:-1);touchStart=null;}},{passive:true});
    if(active&&active.dataset.color!=='shared')select(active.dataset.color);else show(active);
    scope?.addEventListener('click',e=>{const swatch=e.target.closest('[data-uh-swatch]');if(swatch)select(swatch.dataset.value);});
    scope?.addEventListener('change',e=>{const field=e.target.closest('[data-uh-option]');if(field&&/farbe|color|colour/i.test(field.dataset.uhOptionName)&&field.value)select(field.value);});
    scope?.addEventListener('uh:variant-change',e=>{const color=e.detail?.variant?.options?.find(v=>{const key=normalize(v);return thumbs.some(b=>b.dataset.color===(aliases[key]||key));});if(color)select(color);});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uh-header-search"] && !Shopify.designMode) return;
  try {
    (()=>{const init=()=>document.querySelectorAll('[data-uh-header-search]').forEach(search=>{if(search.dataset.ready)return;search.dataset.ready='true';const summary=search.querySelector('summary'),input=search.querySelector('input[type=search]');const close=focus=>{search.open=false;if(focus)summary.focus();};search.addEventListener('toggle',()=>{if(search.open){document.querySelectorAll('.uh-mobile[open]').forEach(menu=>menu.open=false);input.focus();}});search.querySelector('[data-uh-search-close]').addEventListener('click',()=>close(true));document.addEventListener('keydown',event=>{if(event.key==='Escape'&&search.open){event.preventDefault();close(true);}});document.addEventListener('click',event=>{if(search.open&&!search.contains(event.target))close(false);});});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uh-legal-guarantee"] && !Shopify.designMode) return;
  try {
    (() => {
  let opener;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-uh-guarantee-open]');
    const dialog = document.getElementById('UHGuaranteeDialog');
    if (link && dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      opener = link;
      dialog.showModal();
      dialog.scrollTop = 0;
      dialog.querySelector('.uh-guarantee-text').open = window.matchMedia('(max-width:600px)').matches;
    }
    if (event.target.closest('[data-uh-guarantee-close]')) dialog?.close();
    if (event.target === dialog) {
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    }
  });
  document.getElementById('UHGuaranteeDialog')?.addEventListener('close', () => opener?.focus());
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uh-purchase-clean"] && !Shopify.designMode) return;
  try {
    (() => {

    const initializePurchase = (root) => {

      if (root.dataset.uhReady) return;

      const form = root.querySelector('form');

      const master = root.querySelector('[data-uh-variant-id]');

      const optionFieldset = root.querySelector('[data-uh-variant-options]');

      if (!form || !master || !optionFieldset) return;

      let variants;

      try { variants = JSON.parse(root.querySelector('[data-uh-variant-data]').textContent); }

      catch { return; }

      if (!Array.isArray(variants) || !variants.length) return;

      const options = [...optionFieldset.querySelectorAll('[data-uh-option]')];

      const price = root.querySelector('[data-uh-price]');

      const deliveryPrice = root.querySelector('[data-uh-delivery-price]');

      const europePrice = root.querySelector('[data-uh-europe-price]');

      const availability = root.querySelector('[data-uh-availability]');

      const button = root.querySelector('[data-uh-add]');

      const fallback = root.querySelector('[data-uh-variant-fallback]');

      const update = () => {

        const selected = options.map((option) => option.value);

        const variant = variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));

        const complete = selected.every(Boolean) && [...form.querySelectorAll('select[name^="properties["]')].every(input => Boolean(input.value));

        const available = Boolean(variant?.available) && complete;

        master.value = variant ? String(variant.id) : '';

        master.disabled = !variant;

        if (price) price.textContent = variant ? variant.price : root.dataset.priceLabel;

        deliveryPrice.textContent = variant ? variant.deliveryPrice : root.dataset.priceLabel;

        if (europePrice) europePrice.textContent = variant ? variant.europePrice : root.dataset.priceLabel;

        availability.textContent = !complete ? root.dataset.selectLabel : variant ? (available ? (variant.preorder ? root.dataset.preorderLabel : root.dataset.availableLabel) : root.dataset.unavailableLabel) : root.dataset.combinationLabel;

        availability.dataset.stockStatus = !complete ? 'neutral' : !available ? 'unavailable' : variant.preorder ? 'preorder' : 'in-stock';

        button.disabled = !available;

        button.textContent = !complete ? root.dataset.selectLabel : available ? root.dataset.addLabel : root.dataset.unavailableLabel;

        root.querySelectorAll('[data-uh-swatch]').forEach(chip => { chip.setAttribute('aria-pressed', String(options[Number(chip.dataset.optionIndex)]?.value === chip.dataset.value)); });

        const battery = root.querySelector('[data-uh-battery-property]');

        if (battery) {

          battery.disabled = !variant;

          battery.value = variant ? (variant.options.some(value => value.includes('25 km/h')) ? 'Blei-Gel 72 V / 100 Ah' : 'LiFePO₄ 72 V / 150 Ah') : '';

          root.querySelector('[data-uh-battery-summary]').textContent = variant ? battery.value : root.dataset.selectLabel;

        }

        const scope = root.closest('[data-uh-product-scope]');

        const productImage = scope?.querySelector('[data-uh-product-image], .uh-model-visual img, .uh-product-media__item--featured img');

        if (productImage && variant?.image) {

          productImage.src = variant.image;

          productImage.removeAttribute('srcset');

          productImage.alt = variant.imageAlt;

        }

        root.dispatchEvent(new CustomEvent('uh:variant-change', {bubbles: true, detail: {variant}}));

        if (variant?.sku && root.dataset.uhModelSku) {

          let sku = variant.sku.replace(/-(STICK|SEAT|CAPTAIN|BOTH)(?:-(STICK|SEAT|CAPTAIN|BOTH))*$/, '');

          if (sku.startsWith('UH-CABIN-MAX-45-') && !sku.includes('-LFP-')) sku = sku.replace('UH-CABIN-MAX-45-', 'UH-CABIN-MAX-45-LFP-');

          root.dataset.selectedSku = sku;

          root.dispatchEvent(new CustomEvent('uh:configuration-change', {bubbles:true, detail:{sku,modelSku:root.dataset.uhModelSku}}));

        }

      };

      options.forEach(option => {

        if (!option.hasAttribute('data-uh-single-value')) option.value = '';

        const isBattery = /batter|akku/.test(option.dataset.uhOptionName || '');

        const values = [...option.options].filter(value => value.value);

        if (isBattery && values.length === 1 && root.querySelector('.uh-purchase-batteries')) {

          option.value = values[0].value;

          option.closest('.uh-purchase-field').hidden = true;

        }

      });

      const equipmentOption = root.hasAttribute('data-uh-equipment-checkboxes') ? options.find(option => /ausstattung|equipment/i.test(option.dataset.uhOptionName || '')) : null;
      if (equipmentOption) {
        const choices = [...equipmentOption.options].filter(option => option.value);
        const holderChoice = choices.find(option => /gehstock|walking stick/i.test(option.value));
        const baseChoice = choices.find(option => !/gehstock|walking stick/i.test(option.value));
        if (holderChoice && baseChoice) {
          const field = equipmentOption.closest('.uh-purchase-field');
          const english = document.documentElement.lang.startsWith('en');
          const group = document.createElement('div');
          group.className = 'uh-equipment-checkboxes';
          const addChoice = (key, text) => {
            const label = document.createElement('label');
            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.dataset.uhEquipment = key;
            const caption = document.createElement('span');
            caption.textContent = text;
            label.append(checkbox, caption); group.append(label);
            return checkbox;
          };
          const holder = addChoice('holder', english ? 'Walking stick holder, fitted (+€99 incl. VAT)' : 'Gehstockhalterung, montiert (+99 € inkl. MwSt.)');
          const hasSeatChoice = choices.some(option => /kapitän|captain/i.test(option.value)) && choices.some(option => !/kapitän|captain/i.test(option.value));
          const seat = hasSeatChoice ? addChoice('seat', english ? 'Captain seat with headrest (no surcharge)' : 'Kapitänssitz mit Kopfstütze (ohne Aufpreis)') : null;
          const selectEquipment = () => {
            const match = choices.find(option => /gehstock|walking stick/i.test(option.value) === holder.checked && (!seat || /kapitän|captain/i.test(option.value) === seat.checked));
            equipmentOption.value = match ? match.value : ''; update();
          };
          holder.addEventListener('change', selectEquipment);
          seat?.addEventListener('change', selectEquipment);
          equipmentOption.hidden = true;
          equipmentOption.value = baseChoice.value;
          const heading = field.querySelector('label');
          if (heading) { heading.removeAttribute('for'); heading.textContent = english ? 'Optional equipment' : 'Zusatzausstattung'; }
          field.append(group);
        }
      }
      form.addEventListener('change', update);

      root.querySelectorAll('[data-uh-swatch]').forEach(chip => chip.addEventListener('click', () => {

        options[Number(chip.dataset.optionIndex)].value = chip.dataset.value;

        update();

      }));

      form.addEventListener('submit', (event) => {

        update();

        if (button.disabled) event.preventDefault();

      });

      update();

      options.forEach(option => {

        const field = option.closest('.uh-purchase-field');

        if (!field?.querySelector('[data-uh-swatch]')) return;

        option.hidden = true;

        const label = field.querySelector('label');

        if (label) label.removeAttribute('for');

      });

      optionFieldset.hidden = false;

      optionFieldset.disabled = false;

      fallback.hidden = true;

      master.required = false;

      root.dataset.uhReady = 'true';

    };

    const initializeAll = (scope) => {

      if (scope.matches?.('[data-uh-purchase]')) initializePurchase(scope);

      scope.querySelectorAll('[data-uh-purchase]').forEach(initializePurchase);

    };

    if (document.readyState === 'loading') {

      document.addEventListener('DOMContentLoaded', () => initializeAll(document), {once: true});

    } else {

      initializeAll(document);

    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uh-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializePurchase = (root) => {
      if (root.dataset.uhReady) return;
      const form = root.querySelector('form');
      const master = root.querySelector('[data-uh-variant-id]');
      const optionFieldset = root.querySelector('[data-uh-variant-options]');
      if (!form || !master || !optionFieldset) return;
      let variants;
      try { variants = JSON.parse(root.querySelector('[data-uh-variant-data]').textContent); }
      catch { return; }
      if (!Array.isArray(variants) || !variants.length) return;
      const options = [...optionFieldset.querySelectorAll('[data-uh-option]')];
      const price = root.querySelector('[data-uh-price]');
      const deliveryPrice = root.querySelector('[data-uh-delivery-price]');
      const europePrice = root.querySelector('[data-uh-europe-price]');
      const availability = root.querySelector('[data-uh-availability]');
      const button = root.querySelector('[data-uh-add]');
      const fallback = root.querySelector('[data-uh-variant-fallback]');
      const update = () => {
        const selected = options.map((option) => option.value);
        const variant = variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
        const complete = selected.every(Boolean) && [...form.querySelectorAll('select[name^="properties["]')].every(input => Boolean(input.value));
        const available = Boolean(variant?.available) && complete;
        master.value = variant ? String(variant.id) : '';
        master.disabled = !variant;
        if (price) price.textContent = variant ? variant.price : root.dataset.priceLabel;
        deliveryPrice.textContent = variant ? variant.deliveryPrice : root.dataset.priceLabel;
        if (europePrice) europePrice.textContent = variant ? variant.europePrice : root.dataset.priceLabel;
        availability.textContent = !complete ? root.dataset.selectLabel : variant ? (available ? root.dataset.availableLabel : root.dataset.unavailableLabel) : root.dataset.combinationLabel;
        availability.dataset.available = String(available);
        button.disabled = !available;
        button.textContent = !complete ? root.dataset.selectLabel : available ? root.dataset.addLabel : root.dataset.unavailableLabel;
        root.querySelectorAll('[data-uh-swatch]').forEach(chip => { chip.setAttribute('aria-pressed', String(options[Number(chip.dataset.optionIndex)]?.value === chip.dataset.value)); });
        const battery = root.querySelector('[data-uh-battery-property]');
        if (battery) {
          battery.disabled = !variant;
          battery.value = variant ? (variant.options.some(value => value.includes('25 km/h')) ? 'Blei-Gel 72 V / 100 Ah' : 'LiFePO₄ 72 V / 150 Ah') : '';
          root.querySelector('[data-uh-battery-summary]').textContent = variant ? battery.value : root.dataset.selectLabel;
        }
        const scope = root.closest('[data-uh-product-scope]');
        const productImage = scope?.querySelector('[data-uh-product-image], .uh-model-visual img, .uh-product-media__item--featured img');
        if (productImage && variant?.image) {
          productImage.src = variant.image;
          productImage.removeAttribute('srcset');
          productImage.alt = variant.imageAlt;
        }
        root.dispatchEvent(new CustomEvent('uh:variant-change', {bubbles: true, detail: {variant}}));
        if (variant?.sku && root.dataset.uhModelSku) {
          let sku = variant.sku.replace(/-(STICK|SEAT|CAPTAIN|BOTH)(?:-(STICK|SEAT|CAPTAIN|BOTH))*$/, '');
          if (sku.startsWith('UH-CABIN-MAX-45-') && !sku.includes('-LFP-')) sku = sku.replace('UH-CABIN-MAX-45-', 'UH-CABIN-MAX-45-LFP-');
          root.dataset.selectedSku = sku;
          root.dispatchEvent(new CustomEvent('uh:configuration-change', {bubbles:true, detail:{sku,modelSku:root.dataset.uhModelSku}}));
        }
      };
      options.forEach(option => { option.value = ''; });
      form.addEventListener('change', update);
      root.querySelectorAll('[data-uh-swatch]').forEach(chip => chip.addEventListener('click', () => {
        options[Number(chip.dataset.optionIndex)].value = chip.dataset.value;
        update();
      }));
      form.addEventListener('submit', (event) => {
        update();
        if (button.disabled) event.preventDefault();
      });
      update();
      optionFieldset.hidden = false;
      optionFieldset.disabled = false;
      fallback.hidden = true;
      master.required = false;
      root.dataset.uhReady = 'true';
    };
    const initializeAll = (scope) => {
      if (scope.matches?.('[data-uh-purchase]')) initializePurchase(scope);
      scope.querySelectorAll('[data-uh-purchase]').forEach(initializePurchase);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), {once: true});
    } else {
      initializeAll(document);
    }
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
